import { format } from 'date-fns';
import type { FiltersTemperatureControl } from 'hooks/store/temperature-control/use-temperature-control-search-params';
import type { FormSchema } from './form-schema';

const f = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};

export const createFilterParams = (
  formData: FormSchema
): FiltersTemperatureControl => {
  const { eventDate, companyId, temperature, productBatch, ...rest } = formData;

  const productBatchFilter = productBatch?.trim() || undefined;

  return {
    ...rest,
    ...(companyId?.length && { companyId }),
    ...(temperature?.length && { temperature }),
    ...(productBatchFilter && { productBatch: productBatchFilter }),
    ...(eventDate?.from && { eventDateFrom: f(eventDate.from) }),
    ...(eventDate?.to && { eventDateTo: f(eventDate.to) }),
  };
};
